import React from "react";
import {
  Create,
  Edit,
  TextInput,
  LongTextInput,
  ReferenceInput,
  SelectInput,
  BooleanInput,
  NumberInput,
  SelectArrayInput,
  DeleteButton,
  ListButton,
  WithPermission,
} from "admin-on-rest";
//ReferenceArrayInput,
import FlatButton from "material-ui/FlatButton";
import NavigationRefresh from "material-ui/svg-icons/navigation/refresh";

import RichTextInput from "aor-rich-text-input";
import { Field } from "redux-form";
import { CardActions } from "material-ui/Card";
import IconTitle from "../components/icon_title";
import ProductForm from "./ProductForm";
// import EditProductForm from "./EditProductForm";
// import ImageOlaInput from "../components/image/ImageOlaInput";
import { SelectArrayChipInput } from "../components/selectchip";
// import DependentArrayImageInput from "../components/image/DependentArrayImageInput";
// import DependentArrayImageInputProduct from '../components/image/DependentArrayImageInputProduct';
//import SelectProductArrayInput from "./SelectProductArrayInput";
import { renderDateField, renderTimeField } from "../orders/OrderFormField";
import {
  toolbar,
  validateProductCreate,
  productDefaultValue,
} from "./defaultValues";
//validateProductEdit,
import "../components/rich_text/richtextinput.css";

import { ProductEditTabbedForm } from "./form/ProductEditTabbedForm";

const styles = {
  cardActionStyle: {
    zIndex: 2,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
};
const creaditMode = [
  { id: "credit_card", name: "Credit Card" },
  { id: "bank_transfer", name: "Bank Transfer" },
];

const ProductEditActions = ({ basePath, data, refresh }) => {
  return (
    <CardActions style={styles.cardActionStyle}>
      <ListButton basePath={basePath} />
      <WithPermission value={"Admin"}>
        <DeleteButton basePath={basePath} record={data} />
      </WithPermission>
      <FlatButton
        primary
        label='Refresh'
        onClick={refresh}
        icon={<NavigationRefresh />}
      />
    </CardActions>
  );
};

export const choichesProductType = [
  {
    id: "Product",
    name: "resources.products.fieldList.productType.choices.product",
  },
  {
    id: "Ticket",
    name: "resources.products.fieldList.productType.choices.ticket",
  },
  {
    id: "Voucher",
    name: "resources.products.fieldList.productType.choices.voucher",
  },
  {
    id: "Indosat MSP",
    name: "resources.products.fieldList.productType.choices.indosatMsp",
  },
  {
    id: "Corporate Campaign",
    name: "resources.products.fieldList.productType.choices.corporateCampaign",
  },
];

const choichesPlanType = [
  { id: "fpp", name: "Indosat MSP Freedom Postpaid Plus Plan" },
  { id: "sp", name: "Indosat MSP Super Plan" },
];
/*,
  {
    id: "cstore",
    name: "Kioson Indomaret"
  },
  { id: "cimb_clicks", name: "CIMB Clicks" },
  { id: "bca_klikbca", name: "BCA Klikbca" },
  { id: "bca_klikpay", name: "BCA Klikpay" },
  { id: "bri_epay", name: "BRI epay" },
  { id: "telkomsel_cash", name: "Telkomsel Cash" },
  { id: "echannel", name: "Echannel" },
  { id: "bbm_money", name: "BBM Money" },
  { id: "xl_tunai", name: "XL Tunai" },
  { id: "indosat_dompetku", name: "Indosat Dompetku" },
  { id: "mandiri_ecash", name: "Mandiri Ecash" },
  { id: "permata_va", name: "Permata VA" },
  { id: "bca_va", name: "BCA VA" },
  { id: "other_va", name: "Other VA" },
  { id: "kioson", name: "Kioson" },
  { id: "indomaret", name: "Indomaret" },
  { id: "gci", name: "GCI" },
  { id: "danamon_online", name: "Danamon Online" } */
/**
 * 
 * <LongTextInput
      label="resources.products.fieldList.tracking"
      source="tracking"
    />
 */
const ProductCreateForm = (props) => {
  const { permissions, ...rest } = props;
  return (
    <ProductForm
      {...rest}
      defaultValue={productDefaultValue}
      validate={validateProductCreate}
    >
      <BooleanInput
        label='resources.products.fieldList.active'
        source='active'
      />
      {permissions === "Admin" && (
        <ReferenceInput
          label='resources.products.fieldList.account'
          source='account_id'
          reference='accounts'
          defaultValue={1}
        >
          <SelectInput optionText='name' />
        </ReferenceInput>
      )}
      <LongTextInput label='resources.products.fieldList.name' source='name' />
      <SelectInput
        label='resources.products.fieldList.productType.title'
        source='product_type'
        choices={choichesProductType}
        defaultValue={"Product"}
      />
      <TextInput label='resources.products.fieldList.slug' source='slug' />
      <SelectArrayChipInput
        label='resources.products.fieldList.tags'
        source='tags'
        options={{ fullWidth: true }}
      />
      {/* <ReferenceArrayInput
      label={"resources.products.fieldList.collections"}
      source="collections"
      reference="collections"
      allowEmpty
      perPage={1000}
    >
      <SelectProductArrayInput optionText="name" options={{fullWidth:true}}/>
    </ReferenceArrayInput> */}

      <ReferenceInput
        label='resources.products.fieldList.category'
        source='category_id'
        reference='categories'
        allowEmpty
        perPage={1000}
      >
        <SelectInput optionText='name' />
      </ReferenceInput>
      <TextInput
        label='resources.products.fieldList.brand'
        source='brand'
        options={{ fullWidth: true }}
      />
      <NumberInput
        label='resources.products.fieldList.price'
        source='price'
        parse={(v) => v * 1}
      />
      <NumberInput
        label='resources.products.fieldList.discount'
        source='discount'
      />
      <NumberInput
        label='resources.products.fieldList.margin'
        source='margin'
        parse={(v) => v * 1}
      />
      <NumberInput
        label='resources.products.fieldList.partner_margin'
        source='partner_margin'
        parse={(v) => v * 1}
      />
      <NumberInput
        elStyle={{ width: 100 }}
        label='resources.products.fieldList.sortOrder'
        source='sort_order'
        parse={(v) => v * 1}
      />
      <RichTextInput
        source='description'
        name='description'
        toolbar={toolbar}
      />
      {/* <DependentArrayImageInputProduct
      dependsOn={["name", "tags"]}
      toValue={{ name: "" ,tags:[] }}
    >
      <ImageOlaInput
        source="photos"
        toValue={props.toValue}
        labelImage="Photos"
        label=""
        accept="image/*"
      >
        <ImageField source="src" title="title" />
      </ImageOlaInput>
    </DependentArrayImageInputProduct> */}
      <SelectArrayInput
        label='resources.products.fieldList.payment.enabled_payments'
        source='payment.enabled_payments'
        choices={creaditMode}
        options={{ fullWidth: true }}
      />
      <SelectArrayChipInput
        label='resources.products.fieldList.payment.bin'
        source='payment.credit_card.bin'
        options={{ fullWidth: true }}
      />
      <BooleanInput
        label='resources.products.fieldList.payment.installment'
        source='payment.installment'
      />
      <NumberInput
        label='resources.products.fieldList.shipping.weight'
        source='shipping.weight'
      />
      <BooleanInput
        label='resources.products.fieldList.shipping.free_shipping'
        source='shipping.free_shipping'
      />
      <NumberInput
        elStyle={{ width: 100 }}
        label='resources.products.fieldList.shipping.subsidy'
        source='shipping.subsidy'
        parse={(v) => v * 1}
      />
      <Field
        label='Event Date'
        name='event.date'
        source='event.date'
        component={renderDateField}
      />
      <Field
        label='Event Time'
        name='event.date'
        source='event.date'
        component={renderTimeField}
      />
      <LongTextInput
        label='resources.products.fieldList.term'
        source='event.term'
      />
      <ReferenceInput
        label={"resources.products.fieldList.payment.paymentmode"}
        source='payment_mode_id'
        reference='paymentmode'
        allowEmpty
      >
        <SelectInput optionText='name' optionValue='id' />
      </ReferenceInput>
      <SelectInput
        label='resources.products.fieldList.productType.titlePlanType'
        source='plan_type'
        choices={choichesPlanType}
        defaultValue={"fpp"}
        options={{ fullWidth: true }}
      />
    </ProductForm>
  );
};

// const ProductEditForm = ({...props, permissions}) => (
//   <EditProductForm {...props} validate={validateProductEdit}>
//     <BooleanInput label="resources.products.fieldList.active" source="active" />
//     { permissions ==='Admin' && <ReferenceInput label="resources.products.fieldList.account" source="account_id" reference="accounts">
//         <SelectInput optionText="name" />
//     </ReferenceInput>}
//     <LongTextInput label="resources.products.fieldList.name" source="name" />
//     <TextInput label="resources.products.fieldList.slug" source="slug" />
//     <SelectArrayChipInput
//       label="resources.products.fieldList.tags"
//       source="tags"
//     />
//     <ReferenceArrayInput
//       label={"resources.products.fieldList.collections"}
//       source="collections"
//       reference="collections"
//       allowEmpty
//       perPage={1000}
//     >
//       <SelectProductArrayInput optionText="name" />
//     </ReferenceArrayInput>
//     <ReferenceInput
//       label="resources.products.fieldList.category"
//       source="category_id"
//       reference="categories"
//     >
//       <SelectInput optionText="name" />
//     </ReferenceInput>

//     <LongTextInput label="resources.products.fieldList.brand" source="brand" />
//     <NumberInput
//       label="resources.products.fieldList.price"
//       source="price"
//       parse={v => v * 1}
//     />
//     <NumberInput
//       label="resources.products.fieldList.discount"
//       source="discount"
//       hintText="0.1 for 10% or 500000"
//     />
//     <NumberInput
//       label="resources.products.fieldList.margin"
//       source="margin"
//       parse={v => v * 1}
//     />
//     <NumberInput
//       elStyle={{width:100}}
//       label="resources.products.fieldList.sortOrder"
//       source="sort_order"
//       parse={v => v * 1}
//     />
//     <RichTextInput source="description" name="description" toolbar={toolbar}  />
//     {/* <DependentArrayImageInputProduct dependsOn={["name", "tags"]}>
//       <ImageOlaInput
//         source="photos"
//         labelImage="Photos"
//         label=""
//         accept="image/*"
//         maxSize={1048576}
//       >
//         <ImageField source="src" title="title" />
//       </ImageOlaInput>
//     </DependentArrayImageInputProduct> */}
//     <TextInput
//       label="resources.products.fieldList.properties.screenSize"
//       source="properties.Screen size"
//     />
//     <TextInput
//       label="resources.products.fieldList.properties.cpu"
//       source="properties.CPU"
//     />
//     <TextInput
//       label="resources.products.fieldList.properties.resolution"
//       source="properties.Resolution"
//     />
//     <SelectArrayInput
//       label="resources.products.fieldList.payment.enabled_payments"
//       source="payment.enabled_payments"
//       choices={creaditMode}
//       options={{ fullWidth: true }}
//     />
//     <SelectArrayChipInput
//       label="resources.products.fieldList.payment.bin"
//       source="payment.credit_card.bin"
//       options={{ fullWidth: true }}
//     />
//     <BooleanInput
//       label="resources.products.fieldList.payment.installment"
//       source="payment.installment"
//     />
//     <NumberInput
//       label="resources.products.fieldList.shipping.weight"
//       source="shipping.weight"
//     />
//     <BooleanInput
//       label="resources.products.fieldList.shipping.free_shipping"
//       source="shipping.free_shipping"
//     />
//     <Field label="Event Date" name="event.date" source="event.date" component={renderDateField}/>
//     <Field label="Event Time" name="event.date" source="event.date" component={renderTimeField}/>
//     <LongTextInput label="resources.products.fieldList.term" source="event.term" />

//     <ReferenceInput
//       label={"resources.products.fieldList.payment.paymentmode"}
//       source="payment_mode_id"
//       reference="paymentmode"
//     >
//       <SelectInput optionText="name"  optionValue="id"/>
//     </ReferenceInput>
//     <SelectInput label="resources.products.fieldList.productType.titlePlanType" source="plan_type" choices={choichesPlanType} options={{ fullWidth: true }}/>
//   </EditProductForm>
// );

//<ProductCreateForm {...props} />
export const ProductCreate = (props) => (
  <Create
    {...props}
    title={<IconTitle icon='products' title={"resources.products.titleNew"} />}
  >
    {(permissions) => (
      <ProductCreateForm {...props} permissions={permissions} />
    )}
  </Create>
);

export const ProductEdit = (props) => (
  <Edit
    {...props}
    actions={<ProductEditActions />}
    title={<IconTitle icon='products' title={"resources.products.titleEdit"} />}
  >
    {/* {permissions =><ProductEditForm {...props} permissions={permissions} />} */}
    {(permissions) => (
      <ProductEditTabbedForm {...props} permissions={permissions} />
    )}
  </Edit>
);



// WEBPACK FOOTER //
// ./src/products/Create.js